<template>
  <div>
    <footer class="footer">
      <div class="footer-middle">
        <div class="container">
          <div class="row">
            <div class="col-sm-6 col-lg-3 col-xs-12">
              <div class="widget widget-about">
                <img src="/static/images/logo.svg" alt="LSG Stock" style="width:70%" />

              </div>
              <!-- End .widget about-widget -->
            </div>
            <!-- End .col-sm-6 col-lg-3 -->

            <div class="col-sm-6 col-lg-4 col-xs-12">
              <div class="widget">
                <div>
                  <p style="font-size:16px; text-align: justify; color:#333">
                    The LifestyleGarden® Stock programme is fully developed,
                    produced and sold under ScanCom’s strict supervision and
                    within the regulations of ScanCom’s Code of Conduct.
                  </p>
                </div>
              </div>
              <!-- End .widget -->
            </div>
            <!-- End .col-sm-6 col-lg-3 -->
          </div>
          <!-- End .row -->
        </div>
        <!-- End .container -->
      </div>
      <!-- End .footer-middle -->
      <div class="footer-bottom" style="border-top: 1px solid #ddd;">
        <div class="container">
          <div class="row">
            <div class="col-sm-12 col-lg-6">
              <img src="/static/images/scancom-logo.svg" width="50px" style="float: left; margin-right:10px" />
              <p style="font-size:20px; margin-top:5px; font-weight:bold;  color:#02233eff">
                POWERED BY SCANCOM
              </p>
            </div>
            <div class="col-sm-6 col-lg-6 text-right">
              <div class="widget">
                <p>
                  Copyright © {{ year }}. Scancom Company. <br />
                  All Rights Reserved.
                </p>
                <a href="https://www.scancom.net/data-protection-policy/">Privacy Policy</a>
                | <a href="https://www.scancom.net/cookies-policy/">Cookie</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "TheFooter",
  data() {
    return {
      year: ""
    };
  },
  mounted() {
    this.year = new Date().getFullYear();
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/TheFooter.vue